import { DecimalPipe, NgComponentOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import {
  actionInput,
  customComponentType,
  labelType,
  tableConfig,
} from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '@core/services/local/translation.service';
import { DynamicMaskPipe } from '@shared/pipes';
import {
  bootstrapFileEarmarkX,
  bootstrapPlusLg,
  bootstrapTrashFill,
} from '@ng-icons/bootstrap-icons';
import { CustomGroupButtonsComponent } from '../group-buttons/group-buttons.component';
import { IconsComponent } from '../icons/icon.component';
import { CustomButtonComponent } from '../button/button.component';

@Component({
  selector: 'table-component',
  imports: [
    FormsModule,
    TranslateModule,
    NgbPaginationModule,
    DynamicMaskPipe,
    NgComponentOutlet,
    IconsComponent,
    CustomButtonComponent,
  ],
  templateUrl: './table.component.html',
  providers: [DecimalPipe],
})
export class TableComponent<T> {
  @Input({ required: true }) config!: tableConfig<T>;

  protected defaultConfig = {
    columns: [],
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      pageSize: 10,
      totalItems: 0,
    },
    placeholders: {
      loading: {
        rows: 5,
        color: 'info',
      },
      empty: {
        title: {
          key: 'common.records-not-found.title',
        },
        description: 'common.records-not-found.description-default',
        icon: bootstrapFileEarmarkX,
      },
    },
  };

  protected defaultActionInputsConfig: actionInput[] = [
    {
      name: 'create',
      label: 'create',
      icon: bootstrapPlusLg,
      action: (row: any) => {
        console.log('create', row);
      },
    },
    {
      name: 'delete',
      label: 'delete',
      icon: bootstrapTrashFill,
      action: (row: any) => {
        console.log('delete', row);
      },
    },
  ];

  getDefaultActionsCellComponent() {
    return CustomGroupButtonsComponent;
  }

  constructor(private translate: TranslationService) {}

  getDefaultEmptyTitleTranslate(label: labelType) {
    return this.translate
      .translate({
        keys: [label.key],
        params: { [label.key]: label.params },
      })
      .toLowerCase();
  }

  getPlaceholderAmount(amount: number) {
    return Array.from(Array(amount).keys());
  }

  getCustomComponent(component: any, data: any) {
    if(typeof component != 'function'){
      let customComponent = (component as customComponentType)

      return [customComponent.content, { data: data, ...customComponent.data}];
    }
    
    return [component(''), { data: data}];
  }

  // emptyState: {
  //   title: {
  //     key: 'common.records-not-found.title-default',
  //   },
  //   description: 'common.records-not-found.description-default',
  //   icon: bootstrapFileEarmarkX,
  //   action: {
  //     type: 'button',
  //     theme: 'light',
  //     label: {
  //       key: 'app.pageId.upload',
  //     },
  //   } as buttonConfig,
  // },

  // onSort({ column, direction }: SortEvent) {
  //   this.headers.forEach((header) => {
  //     if (header.sortable !== column) {
  //       header.direction = '';
  //     }
  //   });

  //   this.service.sortColumn = column;
  //   this.service.sortDirection = direction;
  // }
}
